import { FC } from 'react'
import { Text } from '@blueprintjs/core'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import Checked from 'images/checked.svg?react'
import Leaf from 'images/leaf.svg?react'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'

type TProps = {}

const LIST = [
  // 'Website builder',
  'Fast checkout',
  'Online courses',
  // 'Tax support',
  'Digital downloads',
  // '20+ currency support',
  'Memberships',
  // 'Upsells',
  'Landing pages',
  // 'Pre-sales',
  ///////////////
  'Blogging',
  // 'Affiliate marketing',
  'Templates',
  'Webinars',
  // 'Built-in SEO',
  'Coaching products',
  // 'Email marketing',
  // 'Coupons',
  // 'Email automations',
  // 'Multimedia products',
]

const ListBlock: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.HomePage)
  return (
    <ResponsiveBlock className="bg-palette-grey py-12" contentClassName="gap-10">
      <div className="flex flex-1 flex-col gap-20">
        <div className="flex flex-col gap-4 whitespace-pre-wrap">
          <Text tagName="span" className="font-body---40px">
            {t('list_block.title')}
          </Text>
          <Text tagName="span" className="font-body---24px text-palette-black--50">
            {t('list_block.caption')}
          </Text>
          <Text tagName="span" className="font-body---24px text-palette-black--50">
            – {t('list_block.author')}
          </Text>
        </div>
        <div className="flex flex-col gap-4">
          <Leaf />
          <Text tagName="span" className="font-body---32px">
            {t('list_block.designed.title')}
          </Text>
          <Text tagName="span" className="font-body---24px text-palette-black--50">
            {t('list_block.designed.caption')}
          </Text>
        </div>
      </div>
      <div className="flex w-4/12">
        <ul className="grid grid-cols-1 gap-x-12 gap-y-4">
          {Array(9)
            .fill(null)
            .map((_, index) => {
              const listNumber = index + 1
              return (
                <li key={listNumber} className="flex gap-2">
                  <Checked className="flex-none translate-y-1.5" />
                  <Text tagName="span" className="font-body---24px text-palette-black--50">
                    {t(`list_block.list.${listNumber}.title`)}
                  </Text>
                </li>
              )
            })}
        </ul>
      </div>
    </ResponsiveBlock>
  )
}

export { ListBlock }
